import { render, staticRenderFns } from "./faturadetay.vue?vue&type=template&id=48d9ea01&"
import script from "./faturadetay.vue?vue&type=script&lang=js&"
export * from "./faturadetay.vue?vue&type=script&lang=js&"
import style0 from "./faturadetay.vue?vue&type=style&index=0&id=48d9ea01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports